import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import update from "immutability-helper";
import DineroSuccessMessage from "./DineroSuccessMessage";
import MigrateData from "./MigrateData";
import ErrorMessage from "../Alerts/ErrorMessage";
import { set } from "../../actions";
import API from "../../actions";

const DineroVerify = props => {
    const [isLoading, setIsLoading] = useState(false);
    const therapist = useSelector(state => state.data.therapist);
    const [isError, setIsError] = useState(false);
    const [isAllDataFailError, setISAllDataFailError] = useState(false);
    const dispatch = useDispatch();
    const [transferredData, setTransferredData] = useState({
        invoice: {
            success: 0,
            fail: 0,
            total: 0,
            error: ""
        },
        contact: {
            success: 0,
            fail: 0,
            total: 0,
            error: ""
        },
        product: {
            success: 0,
            fail: 0,
            total: 0,
            error: ""
        }
    });

    const dineroAllDataStatus = localStorage.getItem("dineroAllDataStatus");
    const fromDate = localStorage.getItem("fromDate");
    const toDate = localStorage.getItem("toDate");
    useEffect(() => {
        const getToken = async () => {
            try {
                setIsLoading(true);
                const params = new URLSearchParams(document.location.search);
                const updateTherapistRes = await API.updateClientDineroData(
                    therapist.id,
                    params.get("code"),
                    fromDate,
                    toDate,
                    dineroAllDataStatus
                );
                if (updateTherapistRes.status === "success") {
                    setTransferredData(JSON.parse(updateTherapistRes.message));
                    const { dineroOrgId, dineroRefreshToken } = updateTherapistRes;
                    if (dineroOrgId || dineroRefreshToken) {
                        dispatch(
                            set({
                                therapist: update(therapist, {
                                    dineroOrgId: { $set: dineroOrgId },
                                    dineroRefreshToken: { $set: dineroRefreshToken }
                                })
                            })
                        );
                    }
                    localStorage.removeItem("fromDate");
                    localStorage.removeItem("toDate");
                    localStorage.removeItem("dineroAllDataStatus");
                } else {
                    if (updateTherapistRes.status === "failed" && updateTherapistRes.message === "") {
                        setISAllDataFailError(true);
                    }
                    setIsError(true);
                    localStorage.removeItem("fromDate");
                    localStorage.removeItem("toDate");
                    localStorage.removeItem("dineroAllDataStatus");
                }
            } catch (err) {
                setIsError(true);
                console.log({ err });
            } finally {
                setIsLoading(false);
            }
        };
        getToken();
    }, []);
    return (
        <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth:"400px", margin:"auto", minHeight:"calc(100vh - 100px)", justifyContent:"center" }}>
            {isError ? (
                <ErrorMessage
                    open={true}
                    handleClose={() => setIsError(false)}
                    text={"Something went wrong...!"}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                   
                />
            ) : isLoading ? (
                <MigrateData />
            ) : (
                <DineroSuccessMessage transferredData={transferredData} isAllDataFailError={isAllDataFailError} />
            )}
        </Box>
    );
};

export default DineroVerify;
